module.exports = __webpack_public_path__ + "static/GlitchlessSonyax5a-944c160ee90da708f4885cad46df2b4d.png";